import fevadLogoPath from 'Assets/images/fevadLogo_compressed.png';
import RgpdModal from 'Components/modals/RgpdModal';
import { PageFullWidth } from 'Ui';
import styled from 'styled-components';

const TermsAndConditionContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  margin: 1.3rem auto 0;
  justify-content: space-between;
  @media screen and (max-width: 48rem) {
    width: calc(96.5% - 2rem);
    align-items: center;
  }
  @media screen and (min-width: 769px) and (max-width: 1024px) {
    width: calc(96.5% - 2rem);
  }
`;

const ImgContainer = styled.div`
  img {
    width: 39px;
    height: 38px;
    flex-shrink: 0;
    @media screen and (max-width: 48rem) {
    }
  }
`;

const SmallLinks = styled.nav<{ $isPaymentRoute?: boolean }>`
  padding: 1.6rem 0 2.5rem 0;
  font-family: var(--font-primary) !important;
  font-weight: 600;
  color: ${({ $isPaymentRoute }) =>
    $isPaymentRoute ? 'var(--design-text-color)' : '#fff'};
  font-size: 1.2rem;
  font-style: normal;
  line-height: 22px; /* 183.333% */
  text-transform: uppercase;
  display: flex;
  flex-wrap: wrap;

  a {
    &:hover {
      color: var(--design-base-color);
    }
  }
  span {
    margin: 0 0.5rem;
  }
  @media screen and (max-width: 48rem) {
    /* width: calc(90% - 2rem); */
    display: flex;
    flex-direction: row;
    font-size: 1rem;
    flex-wrap: wrap;
    padding: 0;
  }
`;

type Props = {
  termsOfSale: string;
  termsAndConditionsOfOffers: string;
  cookieSettings: string;
  isPaymentRoute?: boolean;
};

export const TermsAndCookies = ({
  termsOfSale,
  termsAndConditionsOfOffers,
  cookieSettings,
  isPaymentRoute,
}: Props) => {
  const date = new Date();
  const month = `© BazarChic.com ${date.getFullYear()}`;
  return (
    <PageFullWidth style={{ width: '100%' }}>
      <TermsAndConditionContainer>
      <SmallLinks $isPaymentRoute={isPaymentRoute}>
        <div>{month}</div>
        <span>-</span>
        <div>
          <a
            target="_blank"
            href="https://fr.bazarchic.com/contenu/conditions-generales-de-ventes/"
          >
            {termsOfSale}
          </a>
        </div>
        <span>-</span>
        <div>
          <a
            target="_blank"
            href="https://ressources.bazarchic.com/conditions-des-offres/"
          >
            *{termsAndConditionsOfOffers}
          </a>
        </div>
        <span>-</span>
        <div>
          <a
            href="# "
            onClick={(e) => {
              e.preventDefault();
              RgpdModal({});
            }}
          >
            {cookieSettings}
          </a>
        </div>
      </SmallLinks>
      <ImgContainer>
        <img
          className="footer_partners_img"
          src={fevadLogoPath}
          alt="Fevad"
          loading="lazy"
        />
      </ImgContainer>
      </TermsAndConditionContainer>
    </PageFullWidth>
  );
};
